import React from 'react';
import { gql, useQuery } from '@apollo/client';
import { logoTableItemType } from 'types';

interface LogoTableProps {
  title?: string;
  query?: string | null;
}

const GET_LOGO_TABLES = gql`
  query GET_LOGO_TABLES {
    logoTables(first: 500, orderBy: logoName_ASC) {
      logoName
      logoLink
      logoImage {
        url
      }
      logoType
    }
  }
`;

export default function LogoTable({ title, query }: LogoTableProps) {
  const { loading, data } = useQuery(GET_LOGO_TABLES);
  if (loading) return <div />;
  const { logoTables } = data;

  return (
    <div>
      {!!logoTables && logoTables?.length >= 1 && (
        <section className="container mx-auto px-4 my-8">
          {!!title && (
            <h3 className="text-2xl md:text-4xl col-12 opacity-80 uppercase text-center">
              {title}
            </h3>
          )}
          <div className="grid animate-col-width">
            {logoTables
              .filter(
                (logoTableItem: { logoType: string }) =>
                  logoTableItem.logoType === query,
              )
              .map((logoTableItem: logoTableItemType) => (
                <div
                  className="col-4 md:col-3 lg:col-2 mx-auto flex align-items-center justify-content-center"
                  key={`${logoTableItem.logoName}-${Math.random()}`}>
                  {logoTableItem?.logoLink ? (
                    <a
                      target="_blank"
                      title={logoTableItem.logoName}
                      href={`${logoTableItem.logoLink}`}
                      className="w-full no-underline animate-col-width inline-block hover-reveal-color mx-auto inline-block"
                      rel="noreferrer">
                      <img
                        src={logoTableItem.logoImage?.url}
                        alt={
                          (logoTableItem?.logoName &&
                            logoTableItem?.logoName) ||
                          'client Logo'
                        }
                        className="block mx-auto"
                        style={{ objectFit: 'contain', maxWidth: '140px' }}
                      />
                    </a>
                  ) : (
                    <div className="w-full no-underline animate-col-width mx-auto inline-block">
                      <img
                        src={logoTableItem.logoImage?.url}
                        alt={
                          (logoTableItem?.logoName &&
                            logoTableItem?.logoName) ||
                          'client Logo'
                        }
                        className="block mx-auto hover-reveal-color"
                        style={{ objectFit: 'contain', maxWidth: '140px' }}
                      />
                    </div>
                  )}
                </div>
              ))}
          </div>
        </section>
      )}
    </div>
  );
}
